import React, { useState } from "react";
import { TermsAndPoliciesStyles } from "./termsAndPolicies.styles";
import PrivacyAndPolicies from "../privacyAndPolicies/privacyAndPolicies";

const TermsAndPolicies = () => {
  const classes = TermsAndPoliciesStyles();
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <div id="termAndPolicies" className={classes.container}>
      <div className={classes.innerContainer}>
        <PrivacyAndPolicies
          open={dialogOpen}
          handleDialog={() => setDialogOpen(false)}
        />
        <p>
          By creating your profile you agree to{" "}
          <a
            href="#termsAndPolicies"
            onClick={() => setDialogOpen(true)}
            className={classes.link}
          >
            {" "}
            Mentoro’s Terms and Conditions
          </a>{" "}
          of use. To learn more about how Mentoro collects, uses, shares and
          protects your personal data please read{" "}
          <a
            href="#termsAndPolicies"
            onClick={() => setDialogOpen(true)}
            className={classes.link}
          >
            Mentoro’s Privacy Policy.
          </a>
        </p>
      </div>
    </div>
  );
};

export default TermsAndPolicies;
